import curry from "lodash/fp/curry";

/**
 * Groups consectutive elements in an array based on the isEqual function
 */
export default curry(function groupConsecutiveWith(isEqual, array) {
  return array.reduce((groups, element) => {
    let lastGroup = groups.at(-1);
    if (!lastGroup || !isEqual(lastGroup.at(-1), element)) {
      lastGroup = [];
      groups.push(lastGroup);
    }
    lastGroup.push(element);
    return groups;
  }, []);
});
